/**
 * @file login.tsx
 * @description Компонент для подложки интерфейса на странице Login.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react-redux, react-router-dom]
 * @related-files ['@store/index']
 */

import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from '@store/index';

export const Login = () => {
    const { accessToken } = useSelector((state: RootState) => state.userStore);

    if (accessToken) {
        const base = import.meta.env.VITE_BASE_URL ?? '/';
        const normalizedBase = base.replace(/\/$/, '');
        window.location.href = `${normalizedBase}/`;
        return;
    }

    return (
        <div className="login-layout">
            <Outlet />
        </div>
    );
};
